import React__default from 'react';
import '../../../@ant-design/cssinjs/es/extractStyle.js';
import '../../../@ant-design/cssinjs/es/hooks/useCacheToken.js';
import '../../../rc-util/es/Dom/dynamicCSS.js';
import '../../../@ant-design/cssinjs/es/StyleContext.js';
import '../../../@ant-design/cssinjs/es/util/index.js';
import '../../../@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../../@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import '../../../@ant-design/cssinjs/es/hooks/useHMR.js';
import '../../../@emotion/unitless/dist/unitless.cjs.js';
import '../../../stylis/dist/umd/stylis.js';
import '../../../rc-util/es/warning.js';
import createTheme from '../../../@ant-design/cssinjs/es/theme/createTheme.js';
import '../../../@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../../@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
import derivative from './themes/default/index.js';
import seedToken from './themes/seed.js';
const defaultTheme = createTheme(derivative);
// ================================ Context =================================
// To ensure snapshot stable. We disable hashed in test env.
const defaultConfig = {
  token: seedToken,
  override: {
    override: seedToken
  },
  hashed: true
};
const DesignTokenContext = /*#__PURE__*/React__default.createContext(defaultConfig);
export { DesignTokenContext, defaultConfig, defaultTheme };
//# sourceMappingURL=context.js.map
